import { memo } from 'react'

import useTranslations from '../../../../hooks/useTranslations'
import ANTDModal from '../../../../shared/antd/ANTDModal'
import ANTDTable from '../../../../shared/antd/ANTDTable'
import { downloadReport } from '../../../../utils/customFunctions'
import { dayJs, SAVE_FORMAT } from '../../../../utils/dayjs'
import { excelLogo } from '../../../../utils/icons'
import { isEqual, length } from '../../../../utils/javascript'

const ViewExcelHistory = ({
  viewReportHistory,
  onViewReportHistory,
  onHistoryTableChange,
  sheetType,
}) => {
  const { t } = useTranslations()
  const { data, loader } = viewReportHistory

  const downloadReportFn = async report => {
    report && (await downloadReport(report))
  }

  const columns = [
    {
      title: t('rpt_StartDate'),
      dataIndex: 'fromDate',
      key: 'rpt_StartDate',
      render: rowData =>
        rowData ? dayJs(rowData, SAVE_FORMAT).format(SAVE_FORMAT) : '-',
    },
    {
      title: t('rpt_EndDate'),
      dataIndex: 'toDate',
      key: 'rpt_EndDate',
      render: rowData =>
        rowData ? dayJs(rowData, SAVE_FORMAT).format(SAVE_FORMAT) : '-',
    },
    {
      title: t('rpt_CreatedDate'),
      key: 'rpt_CreatedDate',
      render: rowData =>
        rowData?.dmsDetails?.modificationDate
          ? dayJs(rowData?.dmsDetails?.modificationDate, SAVE_FORMAT).format(
              SAVE_FORMAT,
            )
          : '-',
    },
    {
      title: t('job_Status'),
      dataIndex: 'status',
      key: 'job_Status',
      render: rowData => rowData || '-',
    },
    {
      title: t('Excel'),
      key: 'Excel',
      render: rowData => {
        const report = rowData?.dmsDetails?.fileUrl
        return (
          <img
            className={
              isEqual(rowData?.status, 'PENDING') ? 'disabled-image' : ''
            }
            src={excelLogo}
            height={60}
            width={50}
            alt="excelImage"
            onClick={() => downloadReportFn(report)}
          />
        )
      },
    },
  ]

  return (
    <ANTDModal
      title={t('rpt_ReportHistory')}
      centered
      open={viewReportHistory?.open}
      onCancel={() => onViewReportHistory({ closeModal: true })}
      footer={false}
      width={1100}
    >
      <ANTDTable
        loading={loader}
        columns={columns}
        dataSource={
          length(data?.list)
            ? data?.list?.map(val => ({ ...val, key: val?.id }))
            : []
        }
        onChange={onHistoryTableChange}
        pagination={{
          lastFetched: data?.pageNo,
          current: data?.pageNo,
          pageSize: 10,
          total: data?.lastPage * data?.pageSize,
          responsive: true,
        }}
      />
    </ANTDModal>
  )
}

export default memo(ViewExcelHistory)
